// Seiten je Version und die Zuordnung zwischen beiden Versionen.
// Version 1 „Original neu gestaltet“: Struktur und Adressen der bisherigen Live Seite.
// Version 2 „Einfaches Deutsch“: Relaunch Struktur.
// Version 3 „Entscheider“: eigene Seitenliste in src/v3/pages.js (Import mit .js Endung, damit Node die Datei lädt).
// Gilt für Umschalter und Nebeneinander: Gibt es die Seite in der anderen Version, bleibt man dort, sonst Startseite.
import { V3_PAGES } from "../v3/pages.js";

const SHARED = [
    "/",
    "/solutions",
    "/solutions/surplus-excess",
    "/solutions/mro-spare-parts",
    "/solutions/obsolete-slow-moving",
    "/solutions/plant-closures",
    "/solutions/plant-closures-restructuring",
    "/solutions/sell-industrial-inventory",
    "/solutions/sell-surplus-inventory",
    "/solutions/sell-machinery-equipment",
    "/company",
    "/ecosystem",
    "/partners",
    "/careers",
    "/contact",
    "/sustainability",
    "/impressum",
    "/datenschutz",
    "/llm-info",
];

export const V1_PAGES = [
    ...SHARED,
    "/infrastructure",
    "/by-role",
    "/by-role/supply-chain-procurement",
    "/by-role/maintenance-mro",
    "/by-role/operations",
    "/by-role/finance",
    "/insights",
    "/insights/references",
    "/insights/case-studies",
    "/insights/articles",
    "/insights/news",
];

export const V2_PAGES = [...SHARED, "/how-it-works", "/references", "/industries", "/services", "/news", "/location", "/quality", "/brands"];

// Ausdrückliche Gegenstücke, alles andere geht über gleiche Adresse oder Startseite
const TO_V1 = { "/how-it-works": "/infrastructure", "/references": "/insights/references", "/news": "/insights/news", "/services": "/infrastructure", "/industries": "/solutions", "/brands": "/ecosystem", "/location": "/company", "/quality": "/company" };
const TO_V2 = { "/insights/news": "/news", "/infrastructure": "/how-it-works", "/platform": "/how-it-works" };

// Version 3: ausdrückliche Gegenstücke (Sitemap nach Briefing vom 22.10.2026).
// Schlüssel in FROM_V3_* gibt es nur in Version 3, darum ändern diese Tabellen nichts am Umschalten zwischen Version 1 und 2.
// /solutions gibt es in allen drei Versionen und bleibt beim Umschalten gleich.
const TO_V3 = {
    "/solutions/surplus-excess": "/solutions/ueberbestaende",
    "/solutions/obsolete-slow-moving": "/solutions/altbestaende-langsamdreher",
    "/solutions/mro-spare-parts": "/solutions/ersatzteile-instandhaltung",
    "/solutions/plant-closures": "/solutions/werksschliessung-restrukturierung",
    "/solutions/sell-surplus-inventory": "/ueberbestaende-verkaufen",
    "/solutions/sell-machinery-equipment": "/maschinen-anlagen-verkaufen",
    "/solutions/sell-industrial-inventory": "/bestaende-verkaufen",
    "/solutions/plant-closures-restructuring": "/standortschliessung",
    "/how-it-works": "/solutions",
    "/services": "/solutions",
    "/infrastructure": "/solutions",
    "/platform": "/solutions",
    "/by-role": "/solutions",
    "/by-role/supply-chain-procurement": "/solutions/einkauf-logistik",
    "/by-role/maintenance-mro": "/solutions/instandhaltung",
    "/by-role/operations": "/solutions/betrieb-geschaeftsfuehrung",
    "/by-role/finance": "/solutions/finanzen-controlling",
    "/industries": "/produkte-und-anlagen",
    "/brands": "/produkte-und-anlagen",
    "/references": "/wissen/referenzen",
    "/news": "/wissen/news-presse",
    "/insights": "/wissen",
    "/insights/references": "/wissen/referenzen",
    "/insights/case-studies": "/wissen/praxisbeispiele",
    "/insights/articles": "/wissen/fachartikel",
    "/insights/news": "/wissen/news-presse",
    "/company": "/unternehmen/ueber-parto",
    "/about": "/unternehmen/ueber-parto",
    "/quality": "/unternehmen/ueber-parto",
    "/location": "/unternehmen/ueber-parto",
    "/ecosystem": "/unternehmen/netzwerk",
    "/partners": "/unternehmen/partner",
    "/sustainability": "/unternehmen/nachhaltigkeit",
    "/careers": "/unternehmen/karriere",
    "/contact": "/kontakt",
};
// Für die Livefassung V3 (frontend/nginx.v3.conf): alte V1/V2 Adressen mit festem Ziel in V3 (301)
export const V3_LEGACY_REDIRECTS = TO_V3;

// Gemeinsame Gegenstücke in Version 1 und 2 (beide kennen diese Adressen)
const FROM_V3_SHARED = {
    "/solutions/ueberbestaende": "/solutions/surplus-excess",
    "/solutions/altbestaende-langsamdreher": "/solutions/obsolete-slow-moving",
    "/solutions/ersatzteile-instandhaltung": "/solutions/mro-spare-parts",
    "/solutions/werksschliessung-restrukturierung": "/solutions/plant-closures",
    "/solutions/verwertung-rohstoffrueckgewinnung": "/sustainability",
    "/ueberbestaende-verkaufen": "/solutions/sell-surplus-inventory",
    "/maschinen-anlagen-verkaufen": "/solutions/sell-machinery-equipment",
    "/bestaende-verkaufen": "/solutions/sell-industrial-inventory",
    "/standortschliessung": "/solutions/plant-closures-restructuring",
    "/unternehmen": "/company",
    "/unternehmen/ueber-parto": "/company",
    "/unternehmen/netzwerk": "/ecosystem",
    "/unternehmen/partner": "/partners",
    "/unternehmen/nachhaltigkeit": "/sustainability",
    "/unternehmen/karriere": "/careers",
    "/kontakt": "/contact",
};
const FROM_V3_TO_V2 = {
    ...FROM_V3_SHARED,
    "/solutions/bestandsanalyse-bewertung": "/services",
    "/solutions/abwicklung-logistik": "/how-it-works",
    "/solutions/marktzugang": "/services",
    "/wissen": "/references",
    "/wissen/referenzen": "/references",
    "/wissen/praxisbeispiele": "/references",
    "/wissen/fachartikel": "/references",
    "/wissen/news-presse": "/news",
};
const FROM_V3_TO_V1 = {
    ...FROM_V3_SHARED,
    "/solutions/bestandsanalyse-bewertung": "/infrastructure",
    "/solutions/abwicklung-logistik": "/infrastructure",
    "/solutions/marktzugang": "/ecosystem",
    "/solutions/betrieb-geschaeftsfuehrung": "/by-role/operations",
    "/solutions/instandhaltung": "/by-role/maintenance-mro",
    "/solutions/einkauf-logistik": "/by-role/supply-chain-procurement",
    "/solutions/finanzen-controlling": "/by-role/finance",
    "/wissen": "/insights",
    "/wissen/referenzen": "/insights/references",
    "/wissen/praxisbeispiele": "/insights/case-studies",
    "/wissen/fachartikel": "/insights/articles",
    "/wissen/news-presse": "/insights/news",
};
// Übrige V3 Seiten (Rollen in V2, Produkte und Anlagen) landen auf der passenden Übersicht.
// Gilt nur für Adressen, die es ausschließlich in Version 3 gibt.
const V3_ONLY = (path) => V3_PAGES.includes(path) && !V1_PAGES.includes(path) && !V2_PAGES.includes(path);
const v3Prefix = (path, to) => {
    if (!V3_ONLY(path)) return null;
    if (path.startsWith("/solutions/")) return "/solutions";
    if (path.startsWith("/produkte-und-anlagen")) return to === "1" ? "/solutions" : "/industries";
    return null;
};
// Alte Beiträge aus Version 1 (/insights/<typ>/<slug>) auf die passende Wissen Seite
const INSIGHT_TYPE_TO_V3 = { "case-studies": "/wissen/praxisbeispiele", articles: "/wissen/fachartikel", news: "/wissen/news-presse", references: "/wissen/referenzen" };

const strip = (p) => {
    const en = p === "/en" || p.startsWith("/en/");
    let path = en ? p.slice(3) || "/" : p || "/";
    if (path.length > 1) path = path.replace(/\/$/, "");
    return { en, path };
};

export const pagesOf = (v) => {
    const s = String(v);
    if (s === "3") return V3_PAGES;
    if (s === "1") return V1_PAGES;
    return V2_PAGES;
};

// Gegenstück einer Adresse in der Zielversion
export const mapPath = (pathname, to) => {
    const { en, path } = strip(pathname);
    let target;
    if (String(to) === "3") {
        const ins = path.match(/^\/insights\/([^/]+)\/[^/]+$/);
        target = TO_V3[path]
            || (V3_PAGES.includes(path) ? path : null)
            || (/^\/careers\/[^/]+$/.test(path) ? "/unternehmen/karriere" : null)
            || (ins ? INSIGHT_TYPE_TO_V3[ins[1]] || "/wissen" : null)
            || (path.startsWith("/insights/") ? "/wissen" : null)
            || "/";
    } else if (String(to) === "1") {
        target = FROM_V3_TO_V1[path]
            || v3Prefix(path, "1")
            || TO_V1[path]
            || (V1_PAGES.includes(path) ? path : null)
            || (/^\/careers\/[^/]+$/.test(path) ? path : null)
            || "/";
    } else {
        target = FROM_V3_TO_V2[path]
            || v3Prefix(path, "2")
            || TO_V2[path]
            || (path.startsWith("/by-role") ? "/solutions" : null)
            || (path.startsWith("/insights") ? "/references" : null)
            || (V2_PAGES.includes(path) ? path : null)
            || (/^\/careers\/[^/]+$/.test(path) ? path : null)
            || "/";
    }
    return en ? (target === "/" ? "/en" : `/en${target}`) : target;
};

// Link Ziel für die aktive Version: gemeinsame Bausteine (Fußzeile, Karten, Buttons) verlinken
// in Version 1 automatisch auf das Gegenstück, wenn es die Seite dort nicht gibt.
// Version 3: bekannte V1/V2 Adressen mit Gegenstück in V3 (Tabelle TO_V3, z. B. /contact, /sustainability,
// /how-it-works) zeigen direkt auf die V3 Adresse, Abfrage (?intent=&situation=&way=) und Anker bleiben erhalten.
// V3 Adressen und Adressen ohne Gegenstück bleiben unverändert.
export const versionPath = (to, v) => {
    if (String(v) === "3") {
        if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
        const i = to.search(/[?#]/);
        const p = i < 0 ? to : to.slice(0, i);
        const { path } = strip(p);
        if (V3_PAGES.includes(path) || path === "/admin") return to;
        const target = mapPath(p, "3");
        if (target === "/" || target === "/en") return to;
        return `${target}${i < 0 ? "" : to.slice(i)}`;
    }
    if (String(v) !== "1" || typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
    const i = to.search(/[?#]/);
    const p = i < 0 ? to : to.slice(0, i);
    const { path } = strip(p);
    if (V1_PAGES.includes(path) || /^\/careers\/[^/]+$/.test(path) || path === "/admin") return to;
    return mapPath(p, "1");
};
